import { useEffect, useState } from 'react';

import { useLazyQuery } from '@apollo/client';
import { Grid } from '@mui/material';

import { showErrorToast } from 'src/components/Toasts/toast';
import { ACCOUNT_MANAGERS } from 'src/graphql/queries/accountManagers.query';

import { PartnerInformationSummaryProps } from '../../step2_PartnerInformation';
import { Field } from '../Field';
import { SectionHeader } from '../SectionHeader';

import VatNumberField from './VatNumberField';

const PartnerInformationSummary = ({ formSummaryData }: PartnerInformationSummaryProps) => {
    const [accountManager, setAccountManager] = useState<string>(null);

    const [accountManagersQuery] = useLazyQuery(ACCOUNT_MANAGERS, {
        onError: (error) => {
            return showErrorToast(error.message);
        },
        onCompleted: (data) => {
            const manager = data?.accountManagers?.find(({ id }) => {
                return id === Number(formSummaryData?.pi_accountManager);
            });
            setAccountManager(`${manager.firstName} ${manager.lastName}`);
        },
    });

    useEffect(() => {
        accountManagersQuery();
    }, []);

    return (
        <>
            <SectionHeader title="Partner Information" />

            <Grid item xs={12} spacing={3} container>
                <Field label="Business Type" value={formSummaryData?.pi_BusinessType} />
                <Grid item lg={6} xs={12} />
                <Field label="Legal Company Name" value={formSummaryData?.pi_legalCompanyName} />
                <Field label="Website" value={formSummaryData?.pi_website} />
                <Field label="Registered Number" value={formSummaryData?.pi_registeredNumber} />
                <Field label="Vat Registered" value={formSummaryData?.pi_vatNumber} isRadioGroup />
                <Field label="Trading Name" value={formSummaryData?.pi_tradingName} />

                <VatNumberField formSummaryData={formSummaryData} />

                <Field label="Account Manager" value={accountManager} />
                <Field label="Credit Limit" value={formSummaryData?.pi_creditLimit} />
                <Field label="Payment Terms" value={formSummaryData?.pi_paymentTerms} />
                <Grid item lg={6} xs={12} display="flex" flexDirection="column" gap="24px" />
            </Grid>
        </>
    );
};

export default PartnerInformationSummary;
